/**
 * Tour Button - Listing action for scheduling tours
 *
 * Neutral outlined button for scheduling property tours and viewing requests.
 * Can be used in footers, cards, CTAs, or any context where tour scheduling
 * is needed.
 */

import { Button } from '../../../ui/Button';

/**
 * Props for listing action buttons
 */
export type ListingActionButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

/**
 * Tour Button Component
 *
 * @example
 * <TourButton
 *   onClick={() => scheduleTour(listing)}
 * />
 */
export const TourButton = ({ onClick, disabled = false }: ListingActionButtonProps) => (
  <Button shape="rectangle" tone="neutral" emphasis="outlined" fluid={true} onClick={onClick} disabled={disabled}>
    Tour
  </Button>
);
